import React, { useEffect, useState } from "react";
import ComingSoon from "../components/ComingSoon";
import BackWithBreadcrumbAppbar from "../components/BackWithBreadcrumbAppbar";
import { useTranslation } from "react-i18next";
import AgendaUI from "../components/AgendaUi";

const WaterTalksProgram = () => {
  const { t } = useTranslation();
  const [agendaData, setAgendaData] = useState(null);

  useEffect(() => {
    fetch("/waterTalkProgram.json")
      .then((response) => response.json())
      .then((data) => setAgendaData(data))
      .catch((error) => console.error("Error loading strategy data:", error));
  }, []);

  if (!agendaData) return null;
  return (
    <>
      <BackWithBreadcrumbAppbar
        links={[{ label: t("dashboard"), href: "/" }]}
        currentPage={t("WaterTalksProgram")}
      />
      <AgendaUI data={agendaData} />
    </>
  );
};

export default WaterTalksProgram;
